export default __webpack_public_path__ + "static/media/company.de1da35b.svg";